module.exports = __webpack_public_path__ + "img/Game1MP.d89c7816.png";